<script lang="ts">
	import Description from '$lib/components/SEO/Description.svelte';
	import Title from '$lib/components/SEO/Title.svelte';
	import HomeLifeInsuranceSimulation from '$lib/components/Simulations/Components/Products/HomeLifeInsuranceSimulation.svelte';
	import __ from '$lib/stores/TranslationStore';
</script>

<svelte:head>
	<Title
		content={$__('Simulador de Seguro de Vida para Crédito Habitação: Calcule a Sua Proteção')}
	/>
	<Description
		content={$__(
			'Garanta a segurança da sua família com o nosso simulador de seguro de vida para crédito habitação. Descubra rapidamente a cobertura ideal ao melhor preço. Proteja o seu lar e a sua família de forma eficiente e ajustada às suas necessidades.'
		)}
	/>
</svelte:head>

<HomeLifeInsuranceSimulation />
